import { AlertTriangle } from "lucide-react";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

type Props = {
  feature: string;
  defaultMessage?: string;
};

export const MaintenanceBanner = ({ feature, defaultMessage }: Props) => {
  const { enabled, message, loading } = useFeatureFlag(feature);
  if (loading || enabled) return null;
  return (
    <div
      role="status"
      className="mx-4 my-3 rounded-2xl border border-amber-300/60 bg-amber-50 dark:bg-amber-950/40 dark:border-amber-700/50 px-4 py-3 flex items-start gap-3"
    >
      <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
      <div className="text-sm text-amber-900 dark:text-amber-100">
        <p className="font-medium">This feature is paused</p>
        <p className="opacity-80">
          {message || defaultMessage || "We are doing a quick fix. Try again in a few minutes."}
        </p>
      </div>
    </div>
  );
};